import React from 'react';
import EChartsReact from 'echarts-for-react';
import { generateColors } from 'utils/helpers';

interface QuestionData {
    name: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any;
}

interface Props {
    data: QuestionData[];
    type: 'pie' | 'donut';
}

const QuestionPieCharts: React.FC<Props> = ({ data, type }) => {
    return (
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                flexDirection: 'row',
                gap: '20px',
                alignItems: 'center',
            }}
        >
            {data?.map((item, index) => {
                const pieData = item?.value?.chart_number?.data?.map(
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (d: any) => ({
                        name: d.name,
                        value: d.value,
                    })
                );

                const option = {
                    color: generateColors(pieData.length),
                    title: {
                        text: item.name,
                        left: 'center',
                        textStyle: {
                            width: 200,
                            overflow: 'truncate',
                        },
                    },
                    tooltip: {
                        trigger: 'item',
                    },
                    legend: {
                        orient: 'horizontal',
                        bottom: 0,
                        icon: 'circle',
                        type: 'scroll',
                    },
                    series: [
                        {
                            name: item.value.question_title,
                            type: 'pie',
                            labelLayout: {
                                hideOverlap: true,
                            },
                            radius: type === 'donut' ? ['45%', '80%'] : '70%',
                            center: ['50%', '50%'],
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            data: pieData.sort(function (a: any, b: any) {
                                return Number(a.value) - Number(b.value);
                            }),
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                                },
                            },
                            label: {
                                show: true,
                                position: 'outside',
                                formatter: '{b}: {c}%',
                                color: '#000',
                            },
                            labelLine: {
                                lineStyle: {
                                    color: 'rgba(255, 255, 255, 0.3)',
                                },
                                smooth: 0.2,
                                length: 10,
                                length2: 20,
                            },
                            animationType: 'scale',
                            animationEasing: 'elasticOut',
                            animationDelay: () => Math.random() * 200,
                        },
                    ],
                };

                return (
                    <div
                        key={index}
                        style={{ width: '400px', height: '400px' }}
                    >
                        <EChartsReact
                            option={option}
                            style={{ height: '100%', width: '100%' }}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default QuestionPieCharts;
